import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

function DragTextDefault() {
	const { t } = useTranslation();
	return <Typography variant="subtitle2">{t('report.achievements.addFileModal.drop')}</Typography>;
}

export default DragTextDefault;
